import { useLayoutEffect, useState } from "react";
import { useAuth } from "../../../../hooks/useAuth";
import useInstitution from "../../../../hooks/useInstitution";
import LogoStore from "../../../../store/logo.store";
import { Avatar, Box, Theme, useMediaQuery } from "@mui/material";
import { styles } from "../styles";
import Logo from "../../../../assets/images/zimba-z.png";
import { USER_TYPES } from "../../../../constants/user-types";
import { H4, Small } from "../../../Typography";

export const SideBarHeader = () => {
  const { user }: any = useAuth();
  const business: any = useInstitution();
  const [logoState, setLogoState] = useState(LogoStore.initialState);

  useLayoutEffect(() => {
    const subscription = LogoStore.subscribe(setLogoState);
    LogoStore.init(business?.logo);

    return () => {
      subscription.unsubscribe();
    };
  }, [business?.logo]);

  const isRightUser = (requiredUsers?: string[]) => {
    if (!requiredUsers) return true;
    return requiredUsers.includes(user?.type);
  };

  return (
    <Box sx={styles.header}>
      <Box sx={{ ...styles.logoContainer }}>
        <Avatar alt="Zimba Logo" src={Logo} sx={{ width: 140, height: 50 }} />
      </Box>
      {!isRightUser([USER_TYPES.SYSTEM_ADMIN]) && (
        <Box sx={styles.institutionLogoContainer}>
          <Box>
            <H4
              sx={{
                textTransform: "capitalize",
                fontWeight: "600",
                lineHeight: 1.2,
              }}
            >
              {user?.first_name || ""} {user?.last_name || ""} {"James Kato"}
            </H4>
            <Small
              sx={{
                textTransform: "capitalize",
                fontSize: "11px",
                color: "#dfdfdf",
                fontWeight: "600",
              }}
            >
              {user?.extra_details?.positiontitle} {"General Manage"}
            </Small>
          </Box>
        </Box>
      )}
    </Box>
  );
};
